import * as _ from "lodash";
import {Dictionary} from "lodash";
import {IComponentOptions} from "angular";
import {StateService} from "@uirouter/angularjs";
import {Application} from "../../shared/model/Application";
import {PriorCourseUnit} from "../../shared/model/PriorCourseUnit";
import {ApplicationService} from "../../shared/application/application.service";
import {PriorCourse} from "../../shared/model/PriorCourse";
import "./application-summary.less";
import {ApplicationCreditSummary} from "../../shared/model/ApplicationCreditSummary";
import {User} from "../../shared/model/User";
import {getSecureDownloadUrl} from "../../shared/utils/attachment-utils";

export class ApplicationSummaryController {

    public studentCreditRequest: Application;
    public applications: Application[];
    public applicationSummaries: ApplicationCreditSummary[];
    public priorUnitMap: Dictionary<PriorCourseUnit>;
    public unitInstitutionMap: any;
    private processing: boolean;
    private currentUser: User;

    /* @ngInject */
    constructor(private $log: ng.ILogService,
                private $state: StateService,
                private $uibModal: any,
                private toaster: any,
                private applicationService: ApplicationService,
                private base64: any) {
        this.$log.debug("ApplicationSummaryController");
    }

    public $onInit() {
        // this.checkStatus(this.studentCreditRequest);

        const priorUnits: PriorCourseUnit[] = this.studentCreditRequest.priorStudies
            .map((course: PriorCourse): PriorCourseUnit[] => {
                return course.units;
            })
            .reduce((units, unit) => {
                return units.concat(unit);
            }, []);

        this.priorUnitMap = _.keyBy(priorUnits, (unit) => unit.unitCode);

        this.unitInstitutionMap = this.studentCreditRequest.priorStudies
            .reduce((previousMap, course: PriorCourse) => {
                const unitMap = {};
                course.units.map((unit) => {
                    unitMap[unit.unitCode] = course.institution;
                });
                return _.merge(previousMap, unitMap);
            }, {});

        this.applicationSummaries = [];
        this.applications.forEach((application) => {
            this.applicationService.getAssessmentsByApplicationId(application.id).then((assessments) => {
                this.applicationSummaries.push(new ApplicationCreditSummary(application, assessments));
                // console.log("Application Summary"); // Calls to 'console.log' are not allowed.
                // console.log(this.applicationSummaries); // Calls to 'console.log' are not allowed.
            });
        });

        this.$log.info("Summaries: %s", this.applicationSummaries);
    }

    /**
     * Generate a secure download URL that goes through the backend proxy.
     */
    public getDownloadUrl(doc, applicationId?: string): string {
        return getSecureDownloadUrl(doc, this.base64, applicationId);
    }

    private isArchivedMedicineApplication(applicationSummary: ApplicationCreditSummary) {
        const MEDICINE_CODE = "50000568";

        // For medicine faculty, we should show "under assessment" when the application is archived.
        // https://trello.com/c/iN0ze2BM/82-in-student-view-change-assessed-for-under-assessment-for-archived-medicine-applications
        return applicationSummary.application.status === "ARCHIVED" || applicationSummary.application.archived
            && applicationSummary.application.owningFacultyCode === MEDICINE_CODE;
    }

    private save(applicationSummary: ApplicationCreditSummary) {
        this.$log.debug("accept");
        this.processing = true;

        this.$uibModal.open({
            component: applicationSummary.someAccepted() ? "acceptCreditModal" : "declineCreditModal",
            resolve: {
                applicationSummary: applicationSummary
            }
        }).result.then((acceptedApplication) => {
            this.$state.go("student.summary", {}, {reload: true});
        }, (reason) => {
            this.$log.info("modal dismissed: " + reason);
            this.processing = false;
        });
    }

    private checkStatus(studentCreditRequest: Application) {
        if (!studentCreditRequest) {
            this.$state.go("student.application");
        } else {
            switch (studentCreditRequest.status) {
                case "DRAFTED":
                case "PENDING_STUDENT_DETAILS":
                case "SUBMITTED":
                case "REOPENED":
                case "UNDER_ASSESSMENT":
                    this.$state.go("student.application");
                    break;
                case "ASSESSED":
                case "ASSESSMENT_COMPLETE":
                    break;
                default:
                    this.invalid();
            }
        }
    }

    private invalid() {
        this.$state.go("invalidStatus",
            {
                message: "Summary page can only be accessed after assessment has been finalized"
            });
    }
}

export const ApplicationSummaryComponent: IComponentOptions = {
    bindings: {
        studentCreditRequest: "<",
        applications: "<"
    },
    controller: ApplicationSummaryController,
    template: require("./application-summary.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/student/application-summary/application-summary.component.ts